//import FingerprintJS from '@fingerprintjs/fingerprintjs'
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import {getMeta} from "@/components/legacy/legacy-core";
import axios from "axios";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";

const DEFAULT_TOKEN = '3tA2GyubJ6MXscjmYDJk';

export class Fingerprint {
  visitorId = null
  data = null
  fpPromise = null
  fp = null
  metaId = null
  publicToken = null

  initEngine() {
    return this.fpPromise = FingerprintJS.load({
      apiKey: this.publicToken,
      region: 'eu'
      //monitoring: false
    });
  }

  getPid() {
    return httpAxiosApi.post('/webapi/other/fp', {
      call: 'pid',
    }).then(result => result.data);
  }

  constructor(publicToken: string = DEFAULT_TOKEN) {
    this.publicToken = publicToken;
    this.metaId = getMeta('publicid', null);

    if (!this.metaId || this.metaId.length == 0)
      this.getPid().then((data) => {
        this.metaId = data.pid;
        this.publicToken = data.pkey;
        this.initEngine().then(fp => {
          this.fp = fp;
          return this.detect(fp)
        })
      });
    else
      this.initEngine().then(fp => {
        this.fp = fp;
        return this.detect(fp)
      });
  }

  detect(fp) {
    if (!this.getLastId())
      fp.get().then(result => {
        this.visitorId = result.visitorId;
        this.data = result;

        if (this.visitorId != this.getLastId)
        {
          axios.post('/webapi/other/fp', {
            call: 'add',
            fingerprint1: this.visitorId,
            fingerprint2: this.visitorId
          });
        }
        this.rememberLastId();
      });
  }

  get storageId() {
    return 'capfp-' + this.metaId;
  }

  rememberLastId() {
    if (this.visitorId)
      localStorage.setItem(this.storageId, this.visitorId);
  }

  clearLastId() {
    localStorage.removeItem(this.storageId);
  }

  getLastId() {
    return localStorage.getItem(this.storageId);
  }
}

/*
export function getFP(fn) {
  Fingerprint2.get((com)=>{
    fn({
      h1: hash64(com),
      h2: hash64(com.filter(v=>!{
        userAgent:1,
        screenResolution:1,
        availableScreenResolution:1,
        plugins:1,
        hasLiedBrowser:1,
        touchSupport:1,
      }[v.key])),
    });
  });
}


 */
